import { render, staticRenderFns } from "./TwoFactorDevice.vue?vue&type=template&id=1370e6a9&scoped=true"
import script from "./TwoFactorDevice.vue?vue&type=script&lang=js"
export * from "./TwoFactorDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370e6a9",
  null
  
)

export default component.exports